import dateFormat from 'date-fns/format';
import { getCurrentDateFormatted } from 'utils/common';

const convertToAmPm = (hour) => {
  if (hour < 0 || hour > 23) return null;
  const specailCase = (hour > 12 ? hour - 12 : hour);
  const period = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour === '0' ? 12 : specailCase;
  return `${hour12} ${period}`;
};

export const getNestedValue = (obj, keys, defaultValue = null) => keys.reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj) ?? defaultValue;

export const getAqiConvertedData = (unformattedData) => {
  const formattedData = unformattedData && Array.isArray(unformattedData) && unformattedData.length > 0 && unformattedData.map((obj) => ({
    timestamp: obj?.last_updated || obj.date,
    avg: obj.componentMap && Object.keys(obj.componentMap).length > 0 && obj.componentMap['AQI-IN']?.sensorData && getNestedValue(obj, ['componentMap', 'AQI-IN', 'sensorData']),
    id: obj?.cityCode,
    name: obj?.cityName,
    state_name: obj?.stateName,
    district_id: obj?.cityCode,
    hour: obj?.hour && convertToAmPm(obj.hour),
    day: obj?.date && formatDayOfWeek(obj.date),
  }));
  return formattedData;
};

export const getWeatherMeterWidget = hallOfFameData => {
  let currentYearData =
    hallOfFameData && Array.isArray(hallOfFameData) ? getAqiConvertedData(hallOfFameData) : (
    Array.isArray(hallOfFameData.sectionitems) &&
    hallOfFameData.sectionitems?.length > 0 &&
    Array.isArray(hallOfFameData.sectionitems[0]?.weeklyCurentYearAQIData) &&
    hallOfFameData.sectionitems[0]?.weeklyCurentYearAQIData?.length > 0 &&
    getAqiConvertedData(hallOfFameData.sectionitems[0]?.weeklyCurentYearAQIData));

  const currentYearSeriesDataFormat =
    currentYearData &&
    Array.isArray(currentYearData) &&
    currentYearData?.length > 0 &&
    currentYearData?.map(item => item?.avg);

  const isHourlyData = currentYearData &&
  Array.isArray(currentYearData) &&
  currentYearData?.length > 0 && currentYearData.every((item)=> item.hour);

  const isWeeklyData = currentYearData &&
  Array.isArray(currentYearData) &&
  currentYearData?.length > 0 && currentYearData.length === 7

  let xSeries = isHourlyData ? currentYearData &&
  Array.isArray(currentYearData) &&
  currentYearData?.length > 0 && currentYearData.map((item)=>item?.hour) : currentYearData &&
  Array.isArray(currentYearData) &&
  currentYearData?.length > 0 && currentYearData.map((item)=> getCurrentDateFormatted(item?.timestamp,'day-month'))

  xSeries = isWeeklyData ? currentYearData &&
  Array.isArray(currentYearData) &&
  currentYearData?.length > 0 && currentYearData.map((item)=> getCurrentDateFormatted(item?.timestamp,'day-month')) : xSeries;

  let xAxisInterval = isHourlyData ? 2 : 5
  xAxisInterval = isWeeklyData ? 1 : xAxisInterval

  const endValue = currentYearSeriesDataFormat && Array.isArray(currentYearSeriesDataFormat) && currentYearSeriesDataFormat.length > 0 && Math.max(...currentYearSeriesDataFormat);
  const startValue = currentYearSeriesDataFormat && Array.isArray(currentYearSeriesDataFormat) && currentYearSeriesDataFormat.length > 0 && Math.min(...currentYearSeriesDataFormat);
  const weatherMeterWidget = [
    {
      seriesdata: currentYearSeriesDataFormat,
      sector: 'Last year',
      fundstext: 'AQI',
      hovertext: 'Last Year',
      growth: '100.4',
      yAxisRange: {
        start: startValue < 50 ? 0 : startValue - 50,
        end: endValue + 50,
        interval: '50',
      },
      xAxisRange:xSeries && Array.isArray(xSeries) && xSeries.length > 0 && xSeries || [],
      xAxisInterval

    },
  ];
  return weatherMeterWidget;
};
export const getMetalMeterWidget = (data,metalCapitalized) => {
  // Extract and sort the dates
  const extractKey=Object.keys(data)
  const metalPrices = Array.isArray(extractKey) && extractKey.length>0 &&  extractKey && data[extractKey] && Object.keys(data[extractKey]).length > 0 && data[extractKey[0]];
  const seriesData = Object.entries(metalPrices).map(([_, value]) =>
    value === "NaN" ? 0 : value
  )?.reverse();
  let xseries = Object.keys(metalPrices)
  .map(dateStr => {
    const [day, month, year] = dateStr.split("-");
    const date = new Date(`${year}-${month}-${day}`);
    return `${date.getDate()} ${date.toLocaleString("default", { month: "long" })}`;
  })?.reverse();
 let is7days= xseries && Array.isArray(xseries) && (xseries.length ===7||xseries.length ===6);
  let xAxisInterval = is7days ? 1 : 5;

  const endValue = seriesData && Array.isArray(seriesData) && seriesData.length > 0 && Math.max(...seriesData);
  const startValue = seriesData && Array.isArray(seriesData) && seriesData.length > 0 && Math.min(...seriesData);
  const changeYIntervalForGold= endValue > 100000
  ? 10000
  : endValue > 50000
    ? 1000
    : 200;
    const changeYInterval= endValue > 20000
  ? 1000
  : endValue > 10000
    ? 500
    : 20;
  const yAxisInterval= extractKey[0]==='gold18'|| extractKey[0]==='gold22' || extractKey[0]==='gold24' ? changeYIntervalForGold :changeYInterval;
  const metalMeterWidget = [
    {
      seriesdata:seriesData,
      sector: 'Last year',
      fundstext: `${metalCapitalized} Price (In ₹)`,
      hovertext: 'Last Year',
      growth: '100.4',
      yAxisRange: {
        start: startValue < 50 ? 0 : startValue - 50,
        end: endValue + 50,
        interval: yAxisInterval,
      },
      xAxisRange:xseries && Array.isArray(xseries) && xseries.length > 0 && xseries || [],
      xAxisInterval


    },
  ];
  return metalMeterWidget;
};
export const getMetalPriceTodayFormat = (metal, metalMetrics) => {
  const getPriceData = (entries, labels) =>
    labels.map(({ grams, label }) => {
      const found = entries.find(entry => entry.quantityInGrams === grams);
      return {
        text: label,
        todayPrice: found?.todayPrice?.toLocaleString('en-IN'),
        ...(found?.deviationFromLastPrice !== undefined && {
          deviationFromLastPrice: found?.deviationFromLastPrice,
        }),
      };
    });

  if (metal === 'gold') {
    return Object.entries(metalMetrics).map(([key, value]) => {
      const carat = key.replace('gold', '');
      const entry = value.find(item => item.quantityInGrams === 1);
      return {
        text: `${carat}K gold/gm`,
        todayPrice: entry?.todayPrice,
        ...(entry?.deviationFromLastPrice !== undefined && {
          deviationFromLastPrice: entry.deviationFromLastPrice,
        }),
      };
    });
  }

  const metalData = metalMetrics[metal];
  if (Array.isArray(metalData) && metalData.length > 0) {
    const unitLabels = [
      { grams: 1, label: `${getCapitalizedText(metal)} price/gm` },
      { grams: 1000, label: `${getCapitalizedText(metal)} price/kg` },
    ];
    return getPriceData(metalData, unitLabels);
  }

  return [];
};
export function getGoldPriceTableData(metalData, type) {
  const data = metalData?.metalMetrics?.[type];
  if (!Array.isArray(data) || data.length === 0) return null;

  return data.map(obj => ({
    quantityInGrams: obj.quantityInGrams,
    todayPriceData: {
      todayPrice: obj.todayPrice,
      ...(obj.deviationFromLastPrice !== undefined && {
        deviationFromLastPrice: obj.deviationFromLastPrice,
      }),
    },
    yesterdayPrice: obj.yesterdayPrice || '-',
  }));
}
export const getMonthlyPrice = (metal, MonthlyPriceData) => {
  let requiredKeys = [];

  if (metal === "gold") {
    requiredKeys = ['gold22-1g', 'gold24-1g'];
  } else if (metal === "silver") {
    requiredKeys = ['silver-100g', 'silver-1000g',];
  } else if (metal === "platinum") {
    requiredKeys = ['platinum-100g', 'platinum-1000g',];
  } else {
    return []; 
  }

  // Check if at least one date has all required keys
  const hasValidData = Object.values(MonthlyPriceData).some(metals => {
    return requiredKeys.every(key => metals[key]);
  });

  if (!hasValidData) {
    return [];
  }

  const data = Object.entries(MonthlyPriceData)
    ?.filter(([_, metals]) => requiredKeys.every(key => metals[key]))
    ?.map(([date, metals]) => {
      if (metal === "gold") {
        const gold22 = metals['gold22-1g'];
        const gold24 = metals['gold24-1g'];

        return {
          date: getCurrentDateFormatted(date),
          pergram22: {
            todayPrice: gold22?.price ?? '0',
            ...(gold22?.deviationFromYesterdayPrice !== undefined && {
              deviationFromLastPrice: gold22?.deviationFromYesterdayPrice,
            }),
          },
          pergram24: {
            todayPrice:  gold24?.price ?? '0',
            ...(gold24?.deviationFromYesterdayPrice !== undefined && {
              deviationFromLastPrice: gold24?.deviationFromYesterdayPrice,
            }),
          }
        };
      } else {
        const metal100g = metals[`${metal}-100g`];
        const metal1000g = metals[`${metal}-1000g`];

        return {
          date: getCurrentDateFormatted(date),
          pergram22: {
            todayPrice: metal100g?.price ?? '0',
            ...(metal100g?.deviationFromYesterdayPrice !== undefined && {
              deviationFromLastPrice:metal100g?.deviationFromYesterdayPrice,
            }),
          },
          pergram24:{
            todayPrice: metal1000g?.price ?? '0',
            ...(metal1000g?.deviationFromYesterdayPrice !== undefined && {
              deviationFromLastPrice:metal1000g?.deviationFromYesterdayPrice,
            }),
          }
        };
      }
    });

  return data;
};

// export const getLast30DaysTableData = (metal, MonthlyPriceData) => {
//   const metal100gKey = `${metal}-100g`;
//   const metal1000gKey = `${metal}-1000g`;

//   const data = Object.entries(MonthlyPriceData)
//     ?.filter(([_, metals]) => metals[metal100gKey] && metals[metal1000gKey])
//     ?.map(([date, metals]) => {
//       const metal100g = metals[metal100gKey];
//       const metal1000g = metals[metal1000gKey];

//       return {
//         date: getCurrentDateFormatted(date),
//         pergram22: {
//           todayPrice: metal100g?.price ?? '',
//           deviationFromLastPrice: metal100g?.deviationFromYesterdayPrice ?? '',
//         },
//         pergram24: metal1000g?.price ?? '',
//       };
//     });
//   if (data.length === 0) {
//     return [];
//   }
//   return data;
// };

export const getPopularCityData = (metal, tableData) => {
  if (!Array.isArray(tableData) || tableData.length === 0) return [];

  return tableData.map(cityData => {
    const cityName = cityData?.city;
    const metrics = cityData?.metalMetrics;

    if (metal === 'gold') {
      const gold22 = metrics?.gold22?.find(entry => entry?.quantityInGrams === 1);
      const gold24 = metrics?.gold24?.find(entry => entry?.quantityInGrams === 1);

      if (!gold22 || !gold24) return null;

      return {
        city: cityName,
        pergram22: {
          todayPrice: gold22.todayPrice || '0',
          ...(gold22.deviationFromLastPrice !== undefined && {
            deviationFromLastPrice:gold22.deviationFromLastPrice,
          }),
        },
        pergram24: {
          todayPrice: gold24.todayPrice || '0',
          ...(gold24.deviationFromLastPrice !== undefined && {
            deviationFromLastPrice:gold24.deviationFromLastPrice,
          }),
        }
      };
    } 
    
    const metalData = metrics?.[metal];
    if (!Array.isArray(metalData)) return null;

    const data1g = metalData.find(entry => entry?.quantityInGrams === 1);
    const data10g = metalData.find(entry => entry?.quantityInGrams === 10);

    if (!data1g && !data10g) return null;

    return {
      city: cityName,
      pergram22: {
        todayPrice: data1g?.todayPrice?.toString() || '0',
        ...(data1g?.deviationFromLastPrice !== undefined && {
          deviationFromLastPrice:data1g?.deviationFromLastPrice?.toString(),
        }),
      },
      pergram24: {
        todayPrice: data10g?.todayPrice?.toString() || '0',
        ...(data10g?.deviationFromLastPrice !== undefined && {
          deviationFromLastPrice:data10g?.deviationFromLastPrice?.toString(),
        }),
      }
    };
  }).filter(Boolean);
};

export const getCapitalizedText=(data)=>{
  if(!data){
    return '';
  }
  const result=data?.charAt(0).toUpperCase() + data.slice(1)
  return result;
}

export const getMetalHistoryPriceData = (metal, historyData,currentCity) => {
  const MONTH_MAP = {
    Jan: "January", Feb: "February", Mar: "March",
    Apr: "April", May: "May", Jun: "June",
    Jul: "July", Aug: "August", Sep: "September",
    Oct: "October", Nov: "November", Dec: "December",
  };

  const formatMonthYear = (key) => {
    const [abbr, year] = key.split("-");
    return `${MONTH_MAP[abbr]} ${year}`;
  };

  const getOrdinalSuffix = (num) => {
    const s = ["th", "st", "nd", "rd"];
    const v = num % 100;
    return num + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  const formatDateLabel = (dateStr, label) => {
    if (!dateStr) return "";
    const [day, month] = dateStr.split("-");
    const monthName = new Date(`2000-${month}-01`).toLocaleString("default", { month: "long" });
    return `${getOrdinalSuffix(parseInt(day))} ${monthName} ${label}`;
  };

  const extractDayValue = (metalData = {}, key) => {
    if (!metalData[key] || typeof metalData[key] !== 'object') return { date: null, value: null };
    const entry = Object.entries(metalData[key])[0];
    if (!entry) return { date: null, value: null };
    const [date, value] = entry;
    return { date, value };
  };

  const createTableData = (lowPurity, highPurity, lowLabel, highLabel) => [
    {
      goldrate: formatDateLabel(extractDayValue(lowPurity, "firstDayOfMonth")?.date, "Rate"),
      '22K': extractDayValue(lowPurity, "firstDayOfMonth")?.value?.toLocaleString('en-IN'),
      '24K': extractDayValue(highPurity, "firstDayOfMonth")?.value?.toLocaleString('en-IN'),
    },
    {
      goldrate: formatDateLabel(extractDayValue(lowPurity, "lastDayOfMonth")?.date, "Rate"),
      '22K': extractDayValue(lowPurity, "lastDayOfMonth")?.value?.toLocaleString('en-IN'),
      '24K': extractDayValue(highPurity, "lastDayOfMonth")?.value?.toLocaleString('en-IN'),
    },
    {
      goldrate: "Highest Price of Month",
      '22K': extractDayValue(lowPurity, "highestPriceDayOfMonth")?.value?.toLocaleString('en-IN'),
      '24K': extractDayValue(highPurity, "highestPriceDayOfMonth")?.value?.toLocaleString('en-IN'),
    },
    {
      goldrate: "Lowest Price of Month",
      '22K': extractDayValue(lowPurity, "lowestPriceDayOfMonth")?.value?.toLocaleString('en-IN'),
      '24K': extractDayValue(highPurity, "lowestPriceDayOfMonth")?.value?.toLocaleString('en-IN'),
    },
    {
      goldrate: "Overall Performance",
      '22K': lowPurity?.overallPerformance,
      '24K': highPurity?.overallPerformance,
    },
    {
      goldrate: "% Change",
      '22K': lowPurity?.percentChange,
      '24K': highPurity?.percentChange,
    },
  ];

  const purityKeysMap = {
    gold: ["gold22-1g", "gold24-1g"],
    silver: ["silver-1g", "silver-10g"],
    platinum: ["platinum-1g", "platinum-10g"]
  };

  const [lowPurityKey, highPurityKey] = purityKeysMap[metal.toLowerCase()] || [];

  const isValidData = Object.values(historyData || {}).some((metals) => {
    return Object.keys(metals?.[lowPurityKey] || {}).length > 0 || Object.keys(metals?.[highPurityKey] || {}).length > 0;
  });

  if (!isValidData) return [];

  return Object.entries(historyData).map(([monthKey, metals]) => {
    const lowPurity = metals[lowPurityKey] || {};
    const highPurity = metals[highPurityKey] || {};
    return {
      hl: `${getCapitalizedText(metal)} Price Movement in ${getCapitalizedText(currentCity)} in ${formatMonthYear(monthKey)}`,
      table: createTableData(lowPurity, highPurity, lowPurityKey, highPurityKey),
    };
  });
};


export const getWeeklyColumns = () => {
  const columns = [
    { header: 'Days', accessor: 'timestamp', className: 'w_25' },
    { header: 'Index', accessor: 'index', className: 'w_25' },
    { header: 'AQI Status', accessor: 'status', className: 'w_25' },
  ];
  return columns;
};
export const getColumns = () => {
  const columns = [
    { header: 'Rank', accessor: 'rank', className: 'rank' },
    {
      header: 'City',
      accessor: 'name',
      accessorState: 'state_name',
      className: 'city',
    },
    { header: 'Aqi', accessor: 'avg', className: 'aqi' },
  ];

  return columns;
};

const formatDayOfWeek = (dateStr) => {
  const [day, month, year] = dateStr.split("-").map(Number);
  const date = new Date(year, month - 1, day);
  return new Intl.DateTimeFormat("en-US", { weekday: "short" }).format(date);
};

export const pollutantMapping = {
  pm25: 'Particular Matter',
  pm10: 'Particular Matter',
  co: 'Carbon Monoxide',
  so2: 'Sulphar Dioxide',
  no2: 'Nitrogen Dioxide',
  o3: 'Ozone',
};

export const getAQIClassName = (pollutant, level) => {
  switch (pollutant) {
    case 'pm25':
      switch (true) {
        case level <= 30:
          return 'good_lvl';
        case level <= 60:
          return 'moderate_lvl';
        case level <= 90:
          return 'poor_lvl';
        case level <= 120:
          return 'unhealthy_lvl';
        case level <= 250:
          return 'severe_lvl';
        default:
          return 'hazardous_lvl';
      }

    case 'pm10':
      switch (true) {
        case level <= 50:
          return 'good_lvl';
        case level <= 100:
          return 'moderate_lvl';
        case level <= 250:
          return 'poor_lvl';
        case level <= 350:
          return 'unhealthy_lvl';
        case level <= 430:
          return 'severe_lvl';
        default:
          return 'hazardous_lvl';
      }

    case 'co':
      switch (true) {
        case level <= 8330:
          return 'good_lvl';
        case level <= 16670:
          return 'moderate_lvl';
        case level <= 25000:
          return 'poor_lvl';
        case level <= 33330:
          return 'unhealthy_lvl';
        case level <= 41670:
          return 'severe_lvl';
        default:
          return 'hazardous_lvl';
      }

    case 'so2':
      switch (true) {
        case level <= 40:
          return 'good_lvl';
        case level <= 80:
          return 'moderate_lvl';
        case level <= 380:
          return 'poor_lvl';
        case level <= 800:
          return 'unhealthy_lvl';
        case level <= 1600:
          return 'severe_lvl';
        default:
          return 'hazardous_lvl';
      }

    case 'no2':
      switch (true) {
        case level <= 40:
          return 'good_lvl';
        case level <= 80:
          return 'moderate_lvl';
        case level <= 180:
          return 'poor_lvl';
        case level <= 190:
          return 'unhealthy_lvl';
        case level <= 400:
          return 'severe_lvl';
        default:
          return 'hazardous_lvl';
      }

    case 'o3':
      switch (true) {
        case level <= 50:
          return 'good_lvl';
        case level <= 100:
          return 'moderate_lvl';
        case level <= 168:
          return 'poor_lvl';
        case level <= 208:
          return 'unhealthy_lvl';
        case level <= 748:
          return 'severe_lvl';
        default:
          return 'hazardous_lvl';
      }

    default:
      return '';
  }
};

export const getSpecificDataForPassedKeys = (input, keys) =>
  keys
    .map((key) => {
      if (input && key && input[key]) {
        return { ...input[key], name: pollutantMapping[key] };
      }
      return null;
    })
    .filter((item) => item);

    export const getAQIRangeText = (todayAqiIndex) => {
      if (Number.isNaN(todayAqiIndex)) {
        return '';
      }
    
      switch (!!todayAqiIndex) {
        case todayAqiIndex > 0 && todayAqiIndex <= 50:
          return 'Good';
        case todayAqiIndex > 50 && todayAqiIndex <= 100:
          return 'Moderate';
        case todayAqiIndex > 100 && todayAqiIndex <= 200:
          return 'Poor';
        case todayAqiIndex > 200 && todayAqiIndex <= 300:
          return 'Unhealthy';
        case todayAqiIndex > 300 && todayAqiIndex <= 400:
          return 'Severe';
        case todayAqiIndex > 400:
          return 'Hazardous';
        default:
          return '';
      }
    };

    export const getDateSelectCheck=(date)=>{
      if(!date){
        return;
      }
      let dateFormat='';
      if ( date && date.includes('-')) {
        dateFormat = getCurrentDateFormatted(date);
      } else {
        dateFormat = date;
      }
      return dateFormat;

    }

 export const generateBreadcrumb = (pathname,isMweb = false) => {
  if(!pathname)return { label: "NEWS", link: "/" }
  const parts = pathname?.split("/")?.filter(Boolean);

  return  [
    { label: isMweb ? 'NEWS' : "News", link: "/" },
    ...parts.map((part, index) => ({
      label: decodeURIComponent(part),
      link: "/" + parts.slice(0, index + 1).join("/"),
    }))]
};
